<template>
  <div class="edit-group__media-col ">
    <div class="edit-group__label">{{$tNewVacancy2('Company logo')}}</div>
    <div v-if="imageValue"
         class="edit-group__media-img-wrap">
      <FileShow :value="imageValue"
                class="edit-group__media-img  _cover"/>
      <BasePreloader v-if="companyLogoPending"/>
      <button type="button"
              @click="onDelete"
              class="edit-group__media-btn-delete">
        <BaseSvg name="ico-trash"/>
      </button>
    </div>
    <div v-else
         :class="{'_drag-over': dragoverMixin}"
         @dragover.prevent="onDragoverMixin"
         @dragenter.prevent="onDragenterMixin"
         @dragleave.prevent="onDragleaveMixin"
         @drop.prevent="onDropMixin"
         @click="$refs.fileLogoInput.click()"
         class="edit-group__media-dropzone">
      <input class="d-none"
             type="file"
             ref="fileLogoInput"
             :accept="typeFilesLogo"
             @change="onFilesInputMixin"
      >
      <button type="button"

              class="edit-group__media-btn-add base-btn base-btn--blue">
        <BasePreloader v-if="companyLogoPending"/>
        <BaseSvg name="ico-plus"/>
      </button>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState, mapGetters} from 'vuex'
  import fileUploadMixin from "../../mixins/fileUploadMixin"
  import {ALLOWED_IMAGES_EXTS} from '../../constants/files'
  import FileShow from "../FileShow"

  export default {
    components: {
      FileShow
    },
    mixins: [fileUploadMixin],
    data() {
      return {
        uploadFileMethodNameMixin: ['onUpload']
      }
    },
    computed: {
      ...mapState('vacancyEdit/sectionDescription', [
        'inputs',
        'companyLogo',
        'companyLogoPending',
        'companyLogoError',
      ]),
      ...mapGetters('user', [
        'employerProfile',
      ]),
      typeFilesLogo() {
        const typesString = ALLOWED_IMAGES_EXTS.join(', .')
        return '.' + typesString
      },
      imageValue() {
        const getExtensionFromLink = link => {
          const strings = link.split('.');
          return strings[strings.length - 1];
        };

        const getEmployerProfileLogo = () => {
          const logo = this.inputs.work_place_logo.value;

          if (!logo) return false;
          return { path: logo, ext: getExtensionFromLink(logo) };
        };

        return this.companyLogo || getEmployerProfileLogo()
      },
    },
    methods: {
      ...mapActions('vacancyEdit/sectionDescription', [
        'uploadCompanyLogo',
        'deleteCompanyLogo',
      ]),
      onUpload(files) {
        this.uploadCompanyLogo(files[0])
      },
      onDelete() {
        this.deleteCompanyLogo()
      }
    }
  }
</script>

<style lang="less">

</style>
